/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const utils = require('public/js/helpers/utils');
	const { handleGarageData } = require('public/js/components/garage-store.js');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductFitmentModule() {
		var $fitmentModules;
		let fitmentRequestSeq = 0;

		function getSelectedGarageCar(garage) {
			const cars = Array.isArray(garage) ? garage : handleGarageData.getGarageData();
			if (!Array.isArray(cars)) {
				return null;
			}

			return cars.find((car) => car?.selected) || null;
		}

		function garageCarToPickerLabels(car) {
			return {
				year: utils.getNumberString(car.ui_year ?? car.year) ?? '',
				make: utils.getNonEmptyString(car.ui_make ?? car.make) ?? '',
				model: utils.getNonEmptyString(car.ui_model ?? car.model) ?? '',
				trim: utils.getNonEmptyString(car.ui_trim ?? car.trim) ?? '',
				engine: utils.getNonEmptyString(car.ui_engine ?? car.engine) ?? '',
			};
		}

		function applyUserVehicleFitmentState($fitmentModule, userVehicle, resetPicker = false, garage = null) {
			const $applications = $fitmentModule.find('.product-fitment-applications');
			$fitmentModule.find('.product-fitment-user-fitment').remove();

			const wrapper = $fitmentModule.find('.vehiclepicker_wrapper')[0];
			const selectedGarageCar = resetPicker ? null : getSelectedGarageCar(garage);

			if (wrapper) {
				if (!wrapper.fitmentPickerDefaults) {
					wrapper.fitmentPickerDefaults = {
						year: wrapper.dataset.placeholderYear ?? '',
						make: wrapper.dataset.placeholderMake ?? '',
						model: wrapper.dataset.placeholderModel ?? '',
						trim: wrapper.dataset.placeholderTrim ?? '',
						engine: wrapper.dataset.placeholderEngine ?? '',
					};
				}

				let labels;
				if (userVehicle) {
					labels = {
						year: userVehicle.year != null ? String(userVehicle.year) : '',
						make: userVehicle.make ?? '',
						model: userVehicle.model ?? '',
						trim: userVehicle.trims ?? '',
						engine: userVehicle.engines ?? '',
					};
				} else if (resetPicker || !selectedGarageCar) {
					labels = wrapper.fitmentPickerDefaults;
				} else {
					labels = garageCarToPickerLabels(selectedGarageCar);
				}

				Object.entries(labels).forEach(([step, text]) => {
					if (typeof text !== 'string' || (text === '' && userVehicle)) {
						return;
					}
					const el = wrapper.querySelector(`[data-vehicle-dropdown-button="${step}"] .vpicker-select`);
					if (el) {
						el.textContent = text;
					}
				});
			}

			if (!userVehicle) {
				$applications.show();
				return;
			}

			$fitmentModule.addClass('has-fitment-data');

			const banner = userVehicle.fits_product === true
				? { message: $fitmentModule.data('fitsMessage') || 'Fit', status: 'success', iconWrap: 'success-icon', icon: 'fa-check-circle' }
				: { message: $fitmentModule.data('notFitsMessage') || 'Not fit', status: 'warning', iconWrap: 'warning-icon', icon: 'fa-exclamation-circle' };

			const bannerHtml = `<div class="fitment-warning-message product-fitment-user-fitment ${banner.status}">`
				+ '<a href="javascript:;">'
				+ `<span class="icon-wrap ${banner.iconWrap}"><i class="fa ${banner.icon}"></i></span>${banner.message}`
				+ '</a></div>';

			const $pickerContainer = $fitmentModule.find('.vehicle-picker-container');
			if ($pickerContainer.length > 0) {
				$pickerContainer.append(bannerHtml);
			} else {
				$fitmentModule.find('.product-fitment-vehicle-picker').prepend(bannerHtml);
			}

			$applications.hide();
		}

		function HandleFitmentDataResponse({$fitmentModule}) {
			return function (evt, response) {
				const moduleEle = $fitmentModule.get(0);
				if (moduleEle && response && response.token !== undefined
					&& String(response.token) !== moduleEle.dataset.fitmentRequestSeq) {
					return;
				}

				const fitmentRows = Array.isArray(response.data) ? response.data : [];
				const fitmentLimit = 5;

				// process rows into YMM data that we use for display
				const ymmRows = [];
				fitmentRows.forEach((row) => {
					ymmRows.push({
						year: row.year,
						make: row.make,
						model: row.model,
						trims: row.trims,
						engines: row.engines,
						idx: ymmRows.length + 1,
					});
				});

				// create html for display
				const ymmHtml = ymmRows.map((row) => {
					return `<tr class="fitment-row ${row.idx > fitmentLimit ? 'fitment-hidden' : ''}">
						<td class="fitment-year">${row.year}</td>
						<td class="fitment-make">${row.make}</td>
						<td class="fitment-model">${row.model}</td>
						<td class="fitment-trim">${row.trims.join(', ')}</td>
						<td class="fitment-engine">${row.engines.join(', ')}</td>
					</tr>`;
				}).join('');

				const hasTrimData = ymmRows.some((row) => row.trims.length > 0 );
				const hasEngineData = ymmRows.some((row) => row.engines.length > 0 );

				const $fitmentTable = $fitmentModule.find('.fitment-table');
				$fitmentTable.find('.fitment-table-body').html(ymmHtml);

				// Manage whether we show trim column
				if (hasTrimData) {
					$fitmentTable.removeClass('hide-trim-data');
				} else {
					$fitmentTable.addClass('hide-trim-data');
				}

				// Manage whether we show engine column
				if (hasEngineData) {
					$fitmentTable.removeClass('hide-engine-data');
				} else {
					$fitmentTable.addClass('hide-engine-data');
				}

				// Manage expander
				$fitmentModule.find('.full-count').text(ymmRows.length);
				$fitmentModule.find('.closed-count-total').text(ymmRows.length - fitmentLimit);
				if (ymmRows.length > fitmentLimit) {
					$fitmentModule.find('.fitment-table-wrap').addClass('fitment-closed');
					$fitmentModule.find('.fitment-expander').show();
				} else {
					$fitmentModule.find('.fitment-table-wrap').removeClass('fitment-closed');
					$fitmentModule.find('.fitment-expander').hide();
				}

				if (ymmRows.length > 0) {
					$fitmentModule.addClass('has-fitment-data');
				} else {
					$fitmentModule.removeClass('has-fitment-data');
				}

				$fitmentModule.addClass('loaded');

				applyUserVehicleFitmentState($fitmentModule, response.userVehicle);
			};
		}

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$fitmentModules = rp$('.product-fitment-module');


			const handleUnobserve = (element) => {
				observer.unobserve(element);
			};

			const handleIntersect = (intersects) => {
				for (let i=0; i < intersects.length; i++) {
					const item = intersects[i];
					if (item.intersectionRatio > 0) {
						const moduleEle = item.target;
						handleUnobserve(moduleEle);
						loadProductFitmentData(moduleEle);
					}
				}
			};

			const loadProductFitmentData = (moduleEle) => {
				fitmentRequestSeq += 1;
				moduleEle.dataset.fitmentRequestSeq = String(fitmentRequestSeq);
				moduleEle.classList.add('fitment-requested');
				rp$(document).trigger('productGetFitmentData:request', {
					catalog: moduleEle.dataset.catalog,
					skuStripped: moduleEle.dataset.skuStripped,
					brand: moduleEle.dataset.brand,
					token: fitmentRequestSeq,
				});
			};

			let observer = null;
			if ('IntersectionObserver' in window) {
				observer = new IntersectionObserver(handleIntersect, {
					root: null,
					rootMargin: '0px',
					threshold: 0,
				});
				document.querySelectorAll('.product-fitment-module').forEach((element) => {
					observer.observe(element);
				});
			} else {
				const module = document.querySelector('.product-fitment-module');
				if (module) {
					loadProductFitmentData(module);
				}
			}

			rp$(document)
				.off('garageUpdated.productFitment')
				.on('garageUpdated.productFitment', (eventOrGarage, maybeGarage, ...rest) => {
					const garage = utils.normalizeEventPayloadArgs(eventOrGarage, maybeGarage, rest);
					const hasSelectedVehicle = garage.some((car) => car?.selected);

					document.querySelectorAll('.product-fitment-module.fitment-requested').forEach((moduleEle) => {
						const $fitmentModule = rp$(moduleEle);
						applyUserVehicleFitmentState($fitmentModule, null, !hasSelectedVehicle, garage);
						loadProductFitmentData(moduleEle);
					});
				});

			rp$.each($fitmentModules, function DropDownMenu_Iterator(idx, fitmentModule) {
				var $fitmentModule = rp$(fitmentModule);
				var wrapper = $fitmentModule.find('.fitment-table-wrap');

				const eventHandler = HandleFitmentDataResponse({
					$fitmentModule
				});

				rp$(document).off('productGetFitmentData:response', eventHandler);
				rp$(document).on('productGetFitmentData:response', eventHandler);

				$fitmentModule.on('click', '.fitment-expander', function Expand_Fitment() {
					if(wrapper.hasClass('fitment-closed')){
						wrapper.removeClass('fitment-closed');
					} else {
						wrapper.addClass('fitment-closed');
					}
				});
			});
		}

		function HandleNewProductImagesHtml(evt, html) {
			rp$('.product-fitment-module').html(html);
			attachEvents();
		}

		rp$(document).off('setProductFitment:html', HandleNewProductImagesHtml);
		rp$(document).on('setProductFitment:html', HandleNewProductImagesHtml);

		$onReady({
			rp$, window,
			label: 'product_fitment',
			fn: attachEvents,
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
